const isEqual = require('lodash/isEqual')
const { sanitiseBatchNo, sanitiseManufacturer } = require('./tools')
const batchId = require('../utils/batch-id')

const METADATA = new Set(['_id', '_rev', 'createdAt', 'updatedAt', 'createdBy'])

function createBulkUpsertBatchDetails ({ mainApi, logger }) {
  return async function bulkUpsertBatchDetails (items = []) {
    const now = new Date().toISOString()
    const createdBy = (mainApi.state.user && mainApi.state.user.name) || 'FS backend service'

    const docs = []
    for (const { skuCode, batchNo, manufacturer, expiry } of items) {
      if (!skuCode || !batchNo) continue
      const sanitizedBatchNo = sanitiseBatchNo(batchNo)
      const productId = `product:${skuCode}`
      const manufacturerId = manufacturer && manufacturer !== '' ? manufacturer : 'unknown'
      const sanitizedManufacturer = sanitiseManufacturer(manufacturerId)
      const _id = batchId({ productId, manufacturer: sanitizedManufacturer, batchNo: sanitizedBatchNo })
      docs.push({ _id, type: 'batch', version: '1.0.0', createdAt: now, updatedAt: now, createdBy, manufacturer: manufacturerId, productId, expiry })
    }

    if (docs.length === 0) return

    // Last write wins when the same batch appears multiple times in one payload
    const uniqueDocs = [...new Map(docs.map(d => [d._id, d])).values()]
    const keys = uniqueDocs.map(d => d._id)

    const masterDataDB = mainApi.state.masterDataDB
    const { rows } = await masterDataDB.allDocs({ keys, include_docs: true })

    const toWrite = rows.map((row, i) => {
      const newDoc = uniqueDocs[i]
      if (!row.value || row.value.deleted) return newDoc

      const merged = { ...newDoc, _rev: row.value.rev, createdAt: row.doc.createdAt }
      if (row.doc.alias) merged.alias = row.doc.alias

      const unchanged = Object.keys(merged)
        .filter(k => !METADATA.has(k))
        .every(k => isEqual(row.doc[k], merged[k]))

      return unchanged ? null : merged
    }).filter(Boolean)

    if (toWrite.length === 0) return

    const results = await masterDataDB.bulkDocs(toWrite)
    for (const result of results) {
      if (result.error) {
        logger.warn({ err: result, id: result.id }, 'failed to upsert batch')
      }
    }
  }
}

module.exports = createBulkUpsertBatchDetails
